// Renekton — Dominus: every 3rd auto-attack, Renekton erupts in fury,
// dealing damage and applying a burning DoT to all enemies.

import { effectiveStats } from "../UnitStats";
import { magicDamage } from "../../combat/DamageCalc";
import type { Ability, AbilityHit } from "./Ability";

export const renektonDominus: Ability = {
  id: "renektonDominus",
  displayName: "Dominus",
  description: "Every 3rd attack, erupts in fury — deals 80 magic damage to all enemies and applies a burning DoT.",
  iconId: "RenektonR",

  targetShape({ caster, combat }) {
    if (caster.autoAttackCount % 3 !== 0 || caster.autoAttackCount === 0) return [];
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(enemyTeam).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    if (caster.autoAttackCount % 3 !== 0 || caster.autoAttackCount === 0) return [];
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 0.5 + 88);
    const tickDmg = Math.round(stats.ap * 0.2 + 33);

    return enemies.map((e, i) => ({
      target: e,
      amount: dmg,
      type: "magical" as const,
      suppressPopup: i > 0,
      effect: { kind: "bleed" as const, tickDamage: tickDmg, duration: 3 },
    }));
  },
};
